import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useMemo } from 'react';
import { getTopic, type TopicDto } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export function useTopicDetails(topicId?: number): UseQueryResult<TopicDto, AxiosError> {
    const queryKey = useMemo(() => queryKeys.fullTopics(topicId), [topicId]);

    return useQuery({
        queryKey,
        queryFn: ({ signal }) => getTopic({ path: { id: topicId! }, signal }).then((result) => result.data),
        enabled: !!topicId,
    });
}
